"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanValidator = void 0;
const validator_1 = require("../value/validator");
class BooleanValidator extends validator_1.ValueValidator {
    constructor() {
        super(...arguments);
        this.type = "boolean";
    }
    const(value) {
        return super.const(value);
    }
    enum(...values) {
        return super.enum(...values);
    }
    toSchema(traverser) {
        return {
            type: "boolean",
            ...this.getJsonSchemaObject(traverser),
        };
    }
    clone(clean = false) {
        return this.setupClone(clean, new BooleanValidator());
    }
}
exports.BooleanValidator = BooleanValidator;
